// Locale for dates printed in PDFs: Romanian gets its own format, every other
// language keeps the PDF's previous fixed locale.
export const pdfDateLocale = (language: string, fallback: string): string =>
  language === 'ro' ? 'ro-RO' : fallback;
